import { RouterProvider } from 'react-router';
import { router } from './routes.js';
import { useMe } from './features/auth/hooks.js';
import { useSentryUser } from './lib/sentry.js';

export function App() {
  const { data } = useMe();
  useSentryUser(data);
  return <RouterProvider router={router} />;
}
